<mat-sidenav-container class="sidenav-container main-navigation" [hasBackdrop]="false" autosize>
  <mat-sidenav opened #matSidenavDrawer [mode]="isHandset ? 'over' : 'push'" fixedInViewport>
    <app-menu></app-menu>
  </mat-sidenav>
  <mat-sidenav-content class="sideNavContent" style="margin-right: 0 !important;">
    <mat-toolbar color="primary">
      <button class="back-button" mat-icon-button (click)="matSidenavDrawer.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-notifications></app-notifications>
